
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.02 8.019c.001.441-.188.861-.52 1.153l-7.434 6.54A1.23 1.23 0 01.44 13.864l6.501-5.72a.167.167 0 000-.25L.44 2.174A1.232 1.232 0 112.066.326l7.432 6.538c.332.292.522.713.523 1.155z"}})])
          )
        }
      }
    